exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app {\n  font-family: 'Avenir', Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-align: center;\n  color: #2c3e50;\n  margin-top: 60px;\n}\n.icon {\n  border-radius: 50%;\n  padding: 12px 16px; /* Some padding */\n  font-size: 16px; /* Set a font size */\n}\n.event {\n  background-color: lightgray;\n  margin: 10px;\n  padding: 12px 16px; /* Some padding */\n  font-size: 16px; /* Set a font size */\n}\n  ", ""]);

// exports
